module.exports = __webpack_public_path__ + "img/arrows-retweet.8a91efa2.svg";